import { makeStyles } from '@material-ui/core';

import { neutral, red } from 'shared/styles/colors';

export default makeStyles({
  errorState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3rem 1.5rem',
    gap: '0.5rem',
    textAlign: 'center',
  },
  errorTitle: {
    margin: 0,
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: '1.5rem',
    color: neutral[90],
  },
  errorDescription: {
    margin: 0,
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.375rem',
    color: neutral[60],
  },
  retryButton: {
    appearance: 'none',
    font: 'inherit',
    color: neutral.white,
    textAlign: 'center',
    margin: '0.75rem 0 0',
    padding: '0.5rem 1.25rem',
    border: 'none',
    borderRadius: '0.5rem',
    backgroundColor: red[60],
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
    transition: 'background-color 120ms ease',
    '&:hover': {
      backgroundColor: red[70],
    },
    '&:active': {
      backgroundColor: red[80],
    },
    '&:focus-visible': {
      outline: `0.125rem solid ${red[50]}`,
      outlineOffset: '0.125rem',
    },
  },
});
